<rappider-title-toolbar [mainTitle]="mainTitle"
                        [options]="title"
                        [displayToolbar]="displayToolbar"
                        [displayToolbarBackButton]="displayToolbarBackButton">
</rappider-title-toolbar>

<section>
  <rappider-crud-view-edit-form [config]="PROJECT_MODULE_CREATE_FORM_CONFIG"
                                [data]="{}"
                                [submitButtonLoading]="loading"
                                (formSubmit)="onFormSubmit($event)">
  </rappider-crud-view-edit-form>
</section>
